<template>
  <div class="annual-reports">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-inner">
        <h1 class="hero-title">历年报表</h1>
        <p class="hero-desc">
          <span class="block">真实的数据，见证我们的 <span class="highlight">成长</span> 与客户的 <span class="highlight">信任</span></span><br/>
          <span class="block">从项目数量到服务质量，每一个数字都是我们努力的证明！</span>
        </p>
      </div>
    </section>

    <!-- 年度统计 -->
    <section class="section">
      <div class="section-inner">
        <!-- 学年选择器 -->
        <div class="year-selector">
          <button 
            v-for="period in academicYears" 
            :key="period.id"
            :class="['year-btn', { active: selectedPeriod === period.id }]"
            @click="selectPeriod(period.id)"
          >
            {{ period.label }}
          </button>
        </div>
      </div>
    </section>

    <!-- 动态加载对应年份的组件 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <component :is="currentComponent" v-if="currentComponent" />
        <div v-else class="no-data-tip">
          <p>{{ currentPeriodLabel }} 学年数据暂未开放，敬请期待！</p>
        </div>
      </div>
    </section>

    <!-- 快速联系模态框 -->
    <ContactModal :visible.sync="showContact" />
  </div>
</template>

<script>
import ContactModal from "@/components/ContactModal";
import AnnualReport2025_2026 from "@/components/AnnualReport2025_2026";

export default {
  name: "AnnualReports",
  components: { 
    ContactModal,
    AnnualReport2025_2026
  },
  data() {
    return {
      showContact: false,
      selectedPeriod: '2025-2026',
      academicYears: [
        { id: '2025-2026', label: '2025-9月 至 2026-6月' },
        { id: '2026-2027', label: '2026-9月 至 2027-6月' }
      ],
      // 年份与组件的映射关系
      periodComponents: {
        '2025-2026': 'AnnualReport2025_2026',
        // '2026-2027': 'AnnualReport2026_2027', // 未来添加
      }
    }
  },
  computed: {
    currentComponent() {
      return this.periodComponents[this.selectedPeriod] || null
    },
    currentPeriodLabel() {
      const period = this.academicYears.find(p => p.id === this.selectedPeriod)
      return period ? period.label : ''
    }
  },
  mounted() {
    this.increasePageView()
  },
  methods: {
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'annualReports' }
      }).catch(() => {})
    },
    selectPeriod(periodId) {
      this.selectedPeriod = periodId
      
      // 如果没有对应的组件，显示提示
      if (!this.periodComponents[periodId]) {
        const period = this.academicYears.find(p => p.id === periodId)
        this.$message.warning(`${period.label} 学年数据暂未开放，敬请期待！`)
      }
    }
  }
}
</script>

<style scoped>
.annual-reports {
  min-height: 100vh;
  background: #fff;
}

/* Hero Section */
.hero-section {
  background: #fff;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 300px;
}

.hero-inner {
  max-width: 896px;
  margin: 0 auto;
  text-align: center;
}

.hero-title {
  font-size: 36px;
  font-weight: 900;
  color: #4f46e5;
  margin: 0 0 32px;
}

@media (min-width: 768px) {
  .hero-title {
    font-size: 48px;
  }
}

.hero-desc {
  font-size: 18px;
  color: #4b5563;
  line-height: 1.75;
  margin: 0;
}

.highlight {
  color: #2563eb;
  font-weight: 700;
}

/* Section */
.section {
  padding: 80px 32px;
}

.section.bg-gray {
  background: #f9fafb;
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* 学年选择器 */
.year-selector {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 48px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.year-btn {
  padding: 14px 24px;
  font-size: 17px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  letter-spacing: 0.5px;
  border: 2px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 0;
  white-space: nowrap;
}

.year-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.year-btn.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  font-weight: 400;
}

/* 无数据提示 */
.no-data-tip {
  text-align: center;
  padding: 80px 20px;
  color: #9ca3af;
  font-size: 18px;
}

.no-data-tip p {
  margin: 0;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .section {
    padding: 60px 20px;
  }

  .year-selector {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .year-btn {
    padding: 10px 16px;
    font-size: 13px;
  }
}
</style>
